import { AuthClient } from '@micro-frontend-react/employee-experience/lib/AuthClient';
import { GraphClient } from '@micro-frontend-react/employee-experience/lib/GraphClient';
import { HttpClient } from '@micro-frontend-react/employee-experience/lib/HttpClient';
import { IEvlAppState } from './App.types';
import { ITelemetryClient } from '@micro-frontend-react/employee-experience/lib/ITelemetryClient';
import { TelemetryClient } from '@micro-frontend-react/employee-experience/lib/TelemetryClient';
import { ReducerRegistry } from '@micro-frontend-react/employee-experience/lib/ReducerRegistry';
import { Shell } from '@micro-frontend-react/employee-experience/lib/Shell';
import { StoreBuilder } from '@micro-frontend-react/employee-experience/lib/StoreBuilder';
import { userImpersonationReducer } from './redux/reducers/userImpersonationReducer';
import { withStore } from '@micro-frontend-react/employee-experience/lib/withStore';

const telemetryClient: ITelemetryClient = new TelemetryClient({
  instrumentationKey: __INSTRUMENTATION_KEY__,
  UTPConfig: {
    EnvironmentName: __IS_PRODUCTION__ ? 'Production' : 'Non-Production',
    ServiceOffering: 'Human Resources',
    ServiceLine: 'HR Experiences',
    Service: 'HR Document Generation',
    ComponentName: 'Employment Verification Letter',
    ComponentId: 'bfced684-a78d-4b3d-9b1f-ed9bc5a7b2b2',
  },
  defaultProperties: {
    appName: __APP_NAME__,
  },
});
const authClient = new AuthClient(
  {
    auth: {
      clientId: __CLIENT_ID__,
      redirectUri: window.location.origin,
      authority: 'https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47',
    },
  },
  telemetryClient
);
// const authClient = new ADALClient(
//     {
//         clientId: __CLIENT_ID__,
//         redirectUri: `${window.location.origin}/adal.html`,
//     },
//     telemetryClient
// );
const httpClient = new HttpClient(telemetryClient, authClient);
const graphClient = new GraphClient(httpClient);
// const componentLoader = new ComponentLoader(telemetryClient, httpClient);

const reducerRegistry = new ReducerRegistry().register(
  'userImpersonation',
  userImpersonationReducer
);
//const reducerRegistry = new ReducerRegistry();
const storeResult = new StoreBuilder<IEvlAppState>(reducerRegistry, {})
  .configureSaga({ telemetryClient, authClient, httpClient, graphClient })
  //.addRootSagas([userProfileSagas])
  .addRootSagas([])
  .configurePersistor({
    whitelist:
      process.env.NODE_ENV === 'development' ? ['userImpersonation'] : ['userImpersonation'],
    blacklist: ['dynamic'],
  })
  .build();

export const ShellWithStore = withStore(storeResult)(Shell);
